module.exports = __webpack_public_path__ + "img/firefox.d3750b05.svg";